/**
 * ZoomX slot component.  @deprecated ZoomX is deprecated, please use `<[Chart].Zoom/>`  instead.
 */
export const ZoomX = () => null;
/* oxlint-disable-next-line typescript/no-deprecated */
ZoomX['displayName'] = 'ZoomX';
